import { ProfessionTypeEnum } from '~/models';
import { UserProfession, UserSubProfession } from '../enums/UserProfession';
import {
  getShouldAllowOfficeToPostProcedure,
  getShouldAllowOfficeToPostProcedureBasedOnProfession,
} from '../growthbook';
import { EnumHelper } from './EnumHelper';
import { DefaultGeneralSpecialty } from '~/constants';

/**
 * Getting all profession type options available for job posting
 * including sub-professions like {@link UserSubProfession.EFDA}
 *
 * @param {Array.<{code: string, name: string}>} allProfessions - all professions available,
 *  gotten from {@link getAllProfessionals}
 * @param {Object} options - configuration options
 * @param {boolean} options.showEfda - whether to show EFDA sub-profession or not
 * @returns {Array.<{code: string, name: string}>} array of profession type options
 */
export function getAllProfessionTypeOptions(allProfessions, { showEfda = false }) {
  const availableProfessions = [...(allProfessions ?? [])];

  // find DA index
  const daIndex = availableProfessions.findIndex((license) => license.code === UserProfession.DA);

  if (daIndex > -1) {
    // add DA's sub-profession after DA
    const subProfessions = EnumHelper.getObjectKeys(UserSubProfession)
      .filter((subProfession) => !(!showEfda && subProfession === UserSubProfession.EFDA))
      .map((subProfession) => ({
        code: subProfession,
        name: UserSubProfession.getName(subProfession),
      }));

    availableProfessions.splice(daIndex + 1, 0, ...subProfessions);
  }

  // Remove duplicates
  return Array.from(new Set(availableProfessions.map((p) => p.code))).map((code) =>
    availableProfessions.find((p) => p.code === code),
  );
}

export const getIsAllowOfficeToPostProcedure = (professionType, skills) => {
  /** always show procedures when profession is DN */
  const isDNShowProcedures = professionType === UserProfession.getName(ProfessionTypeEnum.DN);

  /** show procedures when profession is DA and specialty is non general densistry */
  const isDAShowProcedures =
    (professionType === UserProfession.getName(ProfessionTypeEnum.DA) ||
      professionType === UserSubProfession.getName(UserSubProfession.EFDA)) &&
    skills !== DefaultGeneralSpecialty;

  /**
   * is show procedure based on (`isDNShowProcedures` == TRUE OR `isDAShowProcedures` == TRUE)
   * AND FF `TEMP-11985-should-allow-office-to-post-procedure-based-on-profession` ON
   *  */
  const isShowProceduresBasedOnProfession =
    (isDNShowProcedures || isDAShowProcedures) &&
    getShouldAllowOfficeToPostProcedureBasedOnProfession();

  /**
   * is show procedure if FF `should-allow-office-to-post-procedure` ON
   * OR `isShowProceduresBasedOnProfession` is TRUE
   *  */
  const isShowProceduresLine =
    getShouldAllowOfficeToPostProcedure() || isShowProceduresBasedOnProfession;

  return isShowProceduresLine;
};
